import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import Env from '../../../env/env';
import {Observable, Subscription} from 'rxjs';
import {ArtworkData} from '../../elastic-utils';

export interface VMAResult {
  loadTime: number;
  id: number;
  liquidity: boolean;
  price: number;
  reliabilityIndex: number;
  bio: string;
  ml: {
    time: number;
    liquidity: boolean;
    price: { [model: string]: number };
    priceError?: string;
    liquidityError?: string;
  };
  comparable: {
    time: number;
    liquidity: boolean;
    price: number;
    neighbors: string;
    priceCase: number;
    priceError?: string;
    liquidityError?: string;
  };
  row: string[];
}

interface EstimateQuery {
  results: VMAResult[];
  columns: string[];
}

@Component({
  selector: 'app-estimate',
  templateUrl: './estimate.component.html',
  styleUrls: ['./estimate.component.css']
})
export class EstimateComponent implements OnInit, OnDestroy {
  ids: string[] = [];
  estimation: ArtworkData = null;
  columns: string[];
  results: VMAResult[];
  query: Subscription;
  error: any;

  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) { }

  ngOnInit() {
    this.ids = this.route.snapshot.queryParamMap.getAll('id');
    if (this.route.snapshot.fragment)
      this.estimation = JSON.parse(unescape(atob(this.route.snapshot.fragment)));

    if (!this.ids.length && this.estimation === null) {
      this.router.navigate([ '/search' ]);
    }

    if (this.estimation === null) {
      let params = new HttpParams();
      this.ids.forEach((id) => {
        params = params.append('id', id);
      });

      this.query = this.http.get<EstimateQuery>(Env.apiUrl + '/vma/estimate', { params }).subscribe((res) => {
        this.results = res.results;
        this.columns = res.columns;
        this.results = this.results.map(r => {
          for (let model in r.ml.price) {
            r.ml.price[model] = Math.floor(r.ml.price[model])
          }
          if (r.comparable.price) {
            r.comparable.price = Math.floor(r.comparable.price);
          }
          return r;
        });
      }, error => {
        this.error = error;
      });
    } else {
      this.query = this.http.post<EstimateQuery>(Env.apiUrl + '/artist/' + this.estimation.artistId + '/estimate', this.estimation)
        .subscribe((res) => {
        this.results = res.results;
        this.columns = res.columns;
        this.results = this.results.map(r => {
          for (let model in r.ml.price) {
            r.ml.price[model] = Math.floor(r.ml.price[model])
          }
          if (r.comparable.price) {
            r.comparable.price = Math.floor(r.comparable.price);
          }
          return r;
        });
      }, error => {
        this.error = error;
      });
    }
  }

  ngOnDestroy() {
    if (this.query) {
      this.query.unsubscribe();
    }
  }

  getColumn(name: string, result: VMAResult) {
    return result.row[this.columns.indexOf(name)] === 'na' ? '' : result.row[this.columns.indexOf(name)];
  }

  getTitle(result: VMAResult) {
    return this.getColumn('line_number', result);
  }

  getDescription(result: VMAResult) {
    let desc = `${
      this.getColumn('artist_name_analysis', result)
    } - ${
      this.getColumn('artwork_name', result)
    }`
      .trim()
      .replace(/\b([a-z])/g, (letter) => {
        return letter.toUpperCase();
      });
    if (this.getColumn('artwork_date', result)) {
      desc += `, ${this.getColumn('artwork_date', result)}`;
    }
    return desc;
  }
}
